import Chatmessages from '../../components/chatmessages/Chatmessages';
import Chatdetail from '../../components/chatdetail/Chatdetail';
import Chatuserlist from '../../components/chatuserlist/Chatuserlist';
import './chat.scss';
import { useEffect } from 'react';
import { useChatDatabase} from "../../lib/chatDatabase";
import { useUserDatabase } from "../../lib/userDatabase";

const Chat = () => {
    const { currentUser, fetchCurrentUser } = useUserDatabase();
    const { currentChatId, currentReceiver, isDetailOpen } = useChatDatabase();

    useEffect(() => {
      fetchCurrentUser();
    }, [fetchCurrentUser]);

    const isChatActive = currentChatId || currentReceiver;

    return (
        <div className={`chat ${isChatActive ? "chat-active" : ""}`}>
            {currentUser && (
                <>
                    <div className="chatlistContainer">
                        <Chatuserlist />
                    </div>

                    <div className="chatMessagesContainer">
                        {isChatActive ? (
                            <Chatmessages />
                        ) : (
                            <div className="noChatSelected">
                                Choose a chat thread to start a conversation.
                            </div>
                        )}
                    </div>
                    
                    <div className={`chatdetailContainer ${isDetailOpen ? "show" : ""}`}>
                        {isChatActive ? (
                            <Chatdetail />
                        ) : (
                            <div className="noChatSelected">
                                No information available.
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}

export default Chat;